import { createStyles, makeStyles, withStyles } from '@material-ui/core';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';

export const useStyles = makeStyles(() =>
  createStyles({
    examinerAssignNumberButton: {
      top: '20px',
      marginRight: '30px',
      width: '175px',
      height: '30px',
    },
    formInput: {
      marginTop: '11px',
      marginLeft: '59px',
      marginRight: '59px',
      marginBottom: '22px',
      padding: '0px',
      width: '348px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      appearance: 'none',
    },
    modalTitle: {
      marginTop: '26px',
      marginLeft: '24px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
      marginBottom: '38px',
    },
    subHeader: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '15px',
      marginLeft: '59px',
    },
    formFields: {
      scrollbarWidth: 'thin',
      maxHeight: '306px',
      overflow: 'auto',
      overflowX: 'hidden',
    },
  }),
);

export const ConfirmButton = withStyles(() => ({
  root: {
    position: 'relative',
    width: '124px',
    padding: '0px 0px 0px 0px',
    height: '36px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    marginLeft: '21px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
    '&:disabled': {
      color: '#FFFFFF',
      backgroundColor: '#2C2D3E4D',
      border: 'solid 1px #2C2D3E4D',
    },
  },
}))(ButtonOne);

export const CancelButton = withStyles(() => ({
  root: {
    width: '143px',
    padding: '0px 0px 0px 0px',
    height: '36px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    marginLeft: '157px',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
  },
}))(ButtonOne);
